export {
  CustomerAreaLayoutShell,
  type CustomerAreaHeaderAction,
  type CustomerAreaHeaderStat,
  type CustomerAreaNavItem,
} from './CustomerAreaLayoutShell'
export { CustomerAreaMetricCard } from './CustomerAreaMetricCard'
export { buildCustomerAreaNavItems } from './navigation'
export { CustomerAreaPageLayout } from './CustomerAreaPageLayout'
export { CustomerAreaQuickActionCard } from './CustomerAreaQuickActionCard'
export { CustomerAreaSurfaceCard } from './CustomerAreaSurfaceCard'
export { CustomerAreaSectionHeader } from './CustomerAreaSectionHeader'
export { EmptyStateBlock, SkeletonBlock, customerMotionTransition } from './CustomerAreaFeedback'
